import React, { useState, useContext } from 'react'
import { AuthContext } from '../../contexts/auth'
import { useNavigate } from 'react-router-dom'
import { api, createSessionEmployee, NameSchool } from '../../Api'
import { loadSchoolAssessmentInfo } from '../../utils/sessionSchool'
import { FiUser, FiLock, FiEye, FiEyeOff, FiAlertCircle, FiExternalLink, FiUsers } from 'react-icons/fi'

import {
    Container,
    Brand,
    BrandMark,
    BrandBody,
    BrandTitle,
    BrandSubtitle,
    BrandFoot,
    FormSide,
    InputArea,
    FormHeading,
    FormTitle,
    FormHint,
    Field,
    Area,
    Input,
    EyeButton,
    Btt,
    TopButtons,
    AccessTopButton,
    ErrorBanner
} from './style'

import {
    SignMessageButton,
    SignMessageButtonText,
    SignMessageButtonTextBold
} from '../../components/Buttons'

import { AtomLogo } from "../../components/AtomLogo";
import { InstallAppButton } from '../../components/InstallAppButton';

import LoadingSpinner from '../../components/Loading'

const SignInEmployee = () => {
    const navigate = useNavigate()
    const { loginEmployee } = useContext(AuthContext)
    const [cpf, setCpf] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const canSubmit = cpf.trim().length > 0 && password.trim().length > 0 && !loading

    const SignClick = async (e) => {
        if (e && e.preventDefault) e.preventDefault()   // evita reload do form
        if (!canSubmit) return

        setErrorMessage('')
        setLoading(true)
        try {
            const response = await createSessionEmployee(cpf, password)

            if (!response) {
                setErrorMessage('CPF ou senha incorretos. Verifique e tente novamente.')
                setLoading(false)
                return
            }

            const data = response.data

            // ── Fluxo de múltiplas escolas ────────────────────────────────
            // Se o funcionário está vinculado a mais de uma escola, não há
            // sessão completa ainda: manda para a tela de seleção de escola.
            if (data.schools) {
                const userCPF = cpf
                if (data.schools && userCPF) {
                    sessionStorage.setItem('schools', JSON.stringify(data.schools))
                    localStorage.setItem('lastLogin', Date.now())
                    navigate('/school/selection', { state: { schools: data.schools, cpf: userCPF } })
                    return
                }
            }

            // ── 1) VALIDA os campos essenciais ANTES de gravar qualquer coisa ─
            // Se algum destes faltar, o sistema quebraria mais adiante por
            // dado ausente. Melhor barrar aqui, na origem, com mensagem clara.
            const essenciais = {
                id: data.id,
                token: data.token,
                type: data.type,
                id_school: data.id_school,
            }
            const faltando = Object.entries(essenciais)
                .filter(([, v]) => v === undefined || v === null || v === '')
                .map(([k]) => k)

            if (faltando.length > 0) {
                console.error('Login incompleto. Campos ausentes na resposta:', faltando)
                setErrorMessage('Sua conta está com dados incompletos. Contate o suporte.')
                setLoading(false)
                return
            }

            // ── 2) SETA O TOKEN NO HEADER PRIMEIRO ────────────────────────────
            // As rotas de nome-da-escola e regime são protegidas (exigem token).
            // Sem esta linha aqui, elas retornam 401 e os dados vêm undefined.
            api.defaults.headers.Authorization = `Bearer ${data.token}`

            // ── 3) Busca NOME DA ESCOLA (não crítico p/ autenticar) ──────────
            let nomeEscola = ''
            try {
                const nameSchool = await NameSchool(data.id_school)
                nomeEscola = nameSchool?.data?.data ?? ''
            } catch (err) {
                console.error('Falha ao buscar nome da escola:', err)
            }

            // ── 3b) Busca e grava assessmentFormat + assessmentRegime ─────────
            // Helper centralizado (mesmo usado no preload e na seleção de escola).
            // O token já está no header (passo 2), então as rotas protegidas
            // respondem 200. Grava direto no sessionStorage lá dentro.
            await loadSchoolAssessmentInfo(data.id_school)

            // ── 4) Grava TUDO de uma vez (síncrono, sem await no meio) ────────
            localStorage.setItem('lastLogin', Date.now())
            sessionStorage.setItem('School', nomeEscola)
            localStorage.setItem('Id_employee', JSON.stringify(data.id))
            sessionStorage.setItem('cpf', data.CPF)
            sessionStorage.setItem('name', data.name)
            localStorage.setItem('name', data.name)
            localStorage.setItem('type', data.type)
            localStorage.setItem('position_at_school', data.position_at_school)
            sessionStorage.setItem('id-school', JSON.stringify(data.id_school))
            sessionStorage.setItem('id_matter', data.id_matter)
            sessionStorage.setItem('id_class', data.id_class)
            sessionStorage.setItem('id_reporter_cardid_class', data.id_reporter_card)
            localStorage.setItem('token', data.token)
            sessionStorage.setItem('token', data.token)
            // (Authorization já foi setado no passo 2)

            // ── 5) VERIFICA que o essencial ficou gravado antes de prosseguir ─
            const gravou =
                sessionStorage.getItem('token') &&
                sessionStorage.getItem('id-school') &&
                localStorage.getItem('Id_employee') &&
                localStorage.getItem('type')

            if (!gravou) {
                setErrorMessage('Não foi possível preparar sua sessão. Tente novamente.')
                setLoading(false)
                return
            }

            // ── 6) Atualiza o contexto e navega ───────────────────────────────
            loginEmployee(data.CPF)
            // navega + recarrega numa ação única (evita a corrida navigate x reload).
            // Como tudo já está garantidamente no storage, a home monta completa.
            window.location.assign('/home/employee')

        } catch (err) {
            console.error('Erro ao entrar:', err)
            setErrorMessage('Não foi possível entrar. Confira seus dados e a conexão, e tente novamente.')
            setLoading(false)
        }
    }

    const maskCPF = (value) => {
        return value
            .replace(/\D/g, '')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
            .slice(0, 14)
    }

    const handleChange = (e) => {
        setCpf(maskCPF(e.target.value))
        if (errorMessage) setErrorMessage('')
    }

    if (loading) {
        return <LoadingSpinner />
    }

    return (
        <Container>
            <Brand>
                <BrandMark>
                    <AtomLogo size={48} nucleus="#ffffff" />
                    <span>Diário Escolar Virtual</span>
                </BrandMark>
                <BrandBody>
                    <BrandTitle>Portal da Instituição de Ensino</BrandTitle>

                    <BrandSubtitle>
                        Acesse para registrar atividades pedagógicas, acompanhar frequências, avaliações, conceitos e informações acadêmicas.
                    </BrandSubtitle>
                </BrandBody>

                <BrandFoot>
                    Ambiente Integrado de Gestão Escolar
                </BrandFoot>
            </Brand>

            <FormSide>
                <InputArea onSubmit={SignClick}>
                    <TopButtons>
                        <AccessTopButton
                            type="button"
                            onClick={() => navigate('/signin/employee-education-department')}
                        >
                            <FiExternalLink size={15} /> Acessar SEMED
                        </AccessTopButton>

                        <AccessTopButton
                            type="button"
                            onClick={() => navigate('/signin/responsible')}
                        >
                            <FiUsers size={15} /> Acessar como pais ou responsável
                        </AccessTopButton>
                    </TopButtons>

                    <FormHeading>
                        <FormTitle>Entrar</FormTitle>
                        <FormHint>Use seu CPF e senha cadastrados.</FormHint>
                    </FormHeading>

                    {errorMessage && (
                        <ErrorBanner role="alert">
                            <FiAlertCircle size={16} /> {errorMessage}
                        </ErrorBanner>
                    )}

                    <Field>
                        CPF
                        <Area $error={!!errorMessage}>
                            <FiUser size={18} />
                            <Input
                                placeholder="000.000.000-00"
                                value={cpf}
                                onChange={handleChange}
                                type="text"
                                inputMode="numeric"
                                autoComplete="username"
                                maxLength="14"
                            />
                        </Area>
                    </Field>

                    <Field>
                        Senha
                        <Area $error={!!errorMessage}>
                            <FiLock size={18} />
                            <Input
                                placeholder="Digite sua senha"
                                value={password}
                                type={showPassword ? 'text' : 'password'}
                                autoComplete="current-password"
                                onChange={(e) => { setPassword(e.target.value); if (errorMessage) setErrorMessage('') }}
                            />
                            <EyeButton
                                type="button"
                                onClick={() => setShowPassword(s => !s)}
                                aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                                title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                            >
                                {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                            </EyeButton>
                        </Area>
                    </Field>

                    <Btt type="submit" disabled={!canSubmit}>Entrar</Btt>

                    <SignMessageButton type="button" onClick={() => navigate('/forgot-password')}>
                        <SignMessageButtonText>Esqueceu sua</SignMessageButtonText>
                        <SignMessageButtonTextBold>senha?</SignMessageButtonTextBold>
                    </SignMessageButton>

                    <InstallAppButton variant="login" />
                </InputArea>
            </FormSide>
        </Container>
    )
}

export default SignInEmployee